export default {
      id: "icon--price-tag-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--price-tag-usage",
      toString: function () {
        return this.url;
      }
    }